import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import AuthService from "../../../Services/auth/authAPI";
import {toast} from "react-toastify";
import CashierAPI from "../../../apis/cashierApi/CashierAPI";

const Cashier_header = () => {

    const navigate = useNavigate();
    const [me, setMe] = useState(AuthService.getAuthenticatedUser());
    const [loading, setLoading] = useState(true);

    const handleLogout = () => {
        AuthService.logout();
        navigate("/login")
    };

    const [setting, setSetting] = useState();

    const fetchSetting = async () => {
        try{
            const data =  await CashierAPI.findSetting();
            setSetting(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };


    useEffect(() => {
        fetchSetting();
    },[]);


    return (
        <header id="header" className="header fixed-top d-flex align-items-center">

            <div className="d-flex align-items-center justify-content-between">
                <Link to="/admin" className="logo d-flex align-items-center">
                    <img src={process.env.PUBLIC_URL + '/assets/img/logo.png'} alt="" />
                    <span className="d-none d-lg-block">KKS GESTION CAISSE</span>
                </Link>
                <i className="bi bi-list toggle-sidebar-btn" id="toggle-sidebar-btn"></i>
            </div>


            <div className="search-bar">
                {setting && <h5 className="text-dark">Taux : <b className="text-primary">{setting.currency} CDF</b></h5>}
            </div>

            <nav className="header-nav ms-auto">
                <ul className="d-flex align-items-center">

                    <li className="nav-item d-block d-lg-none">
                        <a className="nav-link nav-icon search-bar-toggle " href="#">
                            <i className="bi bi-search"></i>
                        </a>
                    </li>

                    <li className="nav-item dropdown pe-3">


                        <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                            <img src="https://img.freepik.com/free-icon/user_318-159711.jpg"
                                 width="32" height="32" alt="John"
                                 className="shadow" />
                            <span className="d-none d-md-block dropdown-toggle ps-2">
                                {me && (<>{me.user.name}</>)}
                            </span>
                        </a>

                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-header">
                                <h6>{me && (<>{me.user.name}</>)}</h6>
                                <span>Caisse</span>
                            </li>
                            <li>
                                <hr className="dropdown-divider" />
                            </li>

                            <li>
                                <button className="dropdown-item d-flex align-items-center text-danger" onClick={handleLogout}>
                                    <i className="bi bi-box-arrow-right"></i>
                                    <span>Se deconnecter</span>
                                </button>
                            </li>

                        </ul>
                    </li>

                </ul>
            </nav>

        </header>
    );
};

export default Cashier_header;